export const countryCapitalsNl: { [key: string]: string } = {
  "ALB": "Tirana",
  "AND": "Andorra la Vella",
  "AUT": "Wenen",
  "BEL": "Brussel",
  "BGR": "Sofia",
  "BIH": "Sarajevo",
  "BLR": "Minsk",
  "CHE": "Bern",
  "CYP": "Nicosia",
  "CZE": "Praag",
  "DEU": "Berlijn",
  "DNK": "Kopenhagen",
  "ESP": "Madrid",
  "EST": "Tallinn",
  "FIN": "Helsinki",
  "FRA": "Parijs",
  "GBR": "Londen",
  "GRC": "Athene",
  "HRV": "Zagreb",
  "HUN": "Boedapest",
  "IRL": "Dublin",
  "ISL": "Reykjavik",
  "ITA": "Rome",
  "KOS": "Pristina",
  "LIE": "Vaduz",
  "LTU": "Vilnius",
  "LUX": "Luxemburg",
  "LVA": "Riga",
  "MCO": "Monaco",
  "MDA": "Chisinau",
  "MKD": "Skopje",
  "MLT": "Valletta",
  "MNE": "Podgorica",
  "NLD": "Amsterdam",
  "NOR": "Oslo",
  "POL": "Warschau",
  "PRT": "Lissabon",
  "ROU": "Boekarest",
  "RUS": "Moskou",
  "SMR": "San Marino",
  "SRB": "Belgrado",
  "SVK": "Bratislava",
  "SVN": "Ljubljana",
  "SWE": "Stockholm",
  "UKR": "Kiev",
  "VAT": "Vaticaanstad",
  "TUR": "Ankara",
  "AZE": "Bakoe",
  "ARM": "Jerevan",
  "GEO": "Tbilisi",
  "ISR": "Jeruzalem",
  "FRO": "Tórshavn"
};
